export const language: any = {
  selected_ingredients: "चयनित सामग्री",
  recommend: "सिफारिश किए गए व्यंजन",
  title_detail: "सुझाई गई रेसिपी",
  share: "साझा करें",
  ingredients: {
    title: `<span class="tracking-tighter whitespace-nowrap">सामग्री</span> <span class="tracking-tighter whitespace-nowrap">(1 सर्विंग)</span>`,
    add_all: "सभी सामग्री जोड़ें",
    view_more: "{number} और सामग्री देखें",
    view_less: "छिपाएं",
    delete_all: "सभी सामग्री हटाएं"
  },
  how_to_cook: "खाना बनाने की विधि",
  video: {
    title: "वीडियो रेसिपी"
  },
  msg: {
    msg_1: "क्या आप वाकई इस सामग्री को हटाना चाहते हैं?",
    msg_2: "क्या आप वाकई सभी सामग्री को हटाना चाहते हैं?",
    msg_3: "क्या आप सामग्री जोड़ना चाहेंगे?",
    msg_4: "क्या आप सभी अनुपलब्ध सामग्री जोड़ना चाहेंगे?",
    msg_5: "क्या आप चयनित सामग्री को अपने शॉपिंग कार्ट में जोड़ना चाहेंगे?",
    msg_6: "यह सामग्री पहले से ही आपके शॉपिंग कार्ट में मौजूद है।",
    confirm: "हाँ",
    cancel: "नहीं"
  },
  recipe_exist_in_cart: "यह सामग्री पहले से ही आपके शॉपिंग कार्ट में है।",
  recipe_want_add_to_cart: "क्या आप चयनित सामग्री को अपने शॉपिंग कार्ट में जोड़ना चाहेंगे?",
  recipe_exist_in_cart_should_exclued: "पहले से ही मौजूदा कार्ट में है, इसलिए इसे छोड़ दिया गया है।",
  calories_description: "इस व्यंजन में अनुमानित {calories} कैलोरी हैं, कृपया अपने स्वास्थ्य के लिए सही चुनाव करें!",
  title_share_sns: "इस रेसिपी को साझा करें",
  copy: "कॉपी करें",
  recipe_add_cart_success: "कार्ट में जोड़ा गया। क्या आप कार्ट स्क्रीन पर जाना चाहेंगे?",
  recipe_close: "बंद करें",
  recipe_move: "जाएं",
  recipe_add_ingredient_success: "चयनित सामग्री जोड़ दी गई है। क्या आप सामग्री स्क्रीन पर जाना चाहेंगे?",
  copied: "कॉपी किया गया",
  text_share_sns: `{recipe_name} यह रेसिपी कैसी लगी?\nHey! Cooker पर देखें!`,
  search: {
    title: "रेसिपी खोजें",
    searching: "Hey Cooker आपके कीवर्ड से मेल खाने वाली रेसिपी खोज रहा है,<br/>कृपया प्रतीक्षा करें!",
    not_found: "अरे, AI शेफ को आपके कीवर्ड से मेल खाने वाला कोई व्यंजन नहीं मिला,<br/>कृपया कोई दूसरा नाम आज़माएं।",
    placeholder: "जिस रेसिपी का नाम आप खोज रहे हैं, उसे दर्ज करें...",
    msg_default_recipe: "आपके पास अभी तक कोई रेसिपी नहीं है।"
  },
  noData: "कोई परिणाम नहीं मिला",
  searching: "खोज जारी है..."
}
